// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-sets-page {
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
}

.custom-sets-page h1 {
  margin-bottom: 0.5rem;
}

.custom-sets-page .subtitle {
  color: #666;
  margin-bottom: 1.5rem;
}

.create-set-btn {
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content h2 {
  margin-bottom: 1.5rem;
  text-align: center;
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
}

.form-group input:focus {
  border-color: #2196F3;
  outline: none;
}

.icon-picker, .color-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.icon-option {
  width: 44px;
  height: 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-option:hover {
  border-color: #2196F3;
}

.icon-option.selected {
  border-color: #2196F3;
  background: #e3f2fd;
}

.color-option {
  width: 44px;
  height: 44px;
  border: 3px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.color-option:hover {
  transform: scale(1.1);
}

.color-option.selected {
  border-color: #333;
  box-shadow: 0 0 0 2px white, 0 0 0 4px #333;
}

.error-message {
  color: #f44336;
  background: #ffebee;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  text-align: center;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.modal-actions .btn {
  flex: 1 1;
  padding: 0.75rem;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #666;
}

.empty-state .empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-state h3 {
  margin-bottom: 0.5rem;
  color: #333;
}

/* Sets grid */
.sets-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.set-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-left: 4px solid var(--set-color, #607D8B);
}

.set-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.set-header:hover {
  background: #f5f5f5;
}

.set-icon {
  font-size: 2rem;
}

.set-info h3 {
  margin: 0;
  font-size: 1.1rem;
}

.set-stats {
  color: #666;
  font-size: 0.9rem;
}

.set-actions {
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f9f9f9;
  border-top: 1px solid #eee;
}

.btn-small {
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
}

.btn-danger {
  background: #f44336;
  color: white;
}

.btn-danger:hover {
  background: #d32f2f;
}

.custom-sets-page .btn,
.custom-sets-page button {
  text-decoration: none;
}

`, "",{"version":3,"sources":["webpack://./src/pages/CustomSets.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".custom-sets-page {\n  padding: 1rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.custom-sets-page h1 {\n  margin-bottom: 0.5rem;\n}\n\n.custom-sets-page .subtitle {\n  color: #666;\n  margin-bottom: 1.5rem;\n}\n\n.create-set-btn {\n  width: 100%;\n  padding: 1rem;\n  font-size: 1.1rem;\n  margin-bottom: 1.5rem;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 400px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content h2 {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n}\n\n.form-group input:focus {\n  border-color: #2196F3;\n  outline: none;\n}\n\n.icon-picker, .color-picker {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.icon-option {\n  width: 44px;\n  height: 44px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.icon-option:hover {\n  border-color: #2196F3;\n}\n\n.icon-option.selected {\n  border-color: #2196F3;\n  background: #e3f2fd;\n}\n\n.color-option {\n  width: 44px;\n  height: 44px;\n  border: 3px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.color-option:hover {\n  transform: scale(1.1);\n}\n\n.color-option.selected {\n  border-color: #333;\n  box-shadow: 0 0 0 2px white, 0 0 0 4px #333;\n}\n\n.error-message {\n  color: #f44336;\n  background: #ffebee;\n  padding: 0.75rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.modal-actions .btn {\n  flex: 1;\n  padding: 0.75rem;\n}\n\n/* Empty state */\n.empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #666;\n}\n\n.empty-state .empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.empty-state h3 {\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n/* Sets grid */\n.sets-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.set-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  border-left: 4px solid var(--set-color, #607D8B);\n}\n\n.set-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.set-header:hover {\n  background: #f5f5f5;\n}\n\n.set-icon {\n  font-size: 2rem;\n}\n\n.set-info h3 {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.set-stats {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.set-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #f9f9f9;\n  border-top: 1px solid #eee;\n}\n\n.btn-small {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.85rem;\n}\n\n.btn-danger {\n  background: #f44336;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #d32f2f;\n}\n\n.custom-sets-page .btn,\n.custom-sets-page button {\n  text-decoration: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
